import React, { Fragment } from "react"

function LoadingHelper({ children, className, numOfItems = 3 }) {
  return (
    <Fragment>
      {Array(numOfItems)
        .fill()
        .map((_, idx) => (
          <div key={idx} className={className}>
            {children}
          </div>
        ))}
    </Fragment>
  )
}

export default LoadingHelper
